import api, { unwrap } from './client';

export async function submitReview(bookingId, rating, comment) {
  return unwrap(await api.post('/reviews', { bookingId, rating, comment }));
}

export async function reviewForBooking(bookingId) {
  return unwrap(await api.get(`/reviews/booking/${bookingId}`));
}

export async function listClinicReviews(clinicId) {
  return unwrap(await api.get(`/reviews/clinic/${clinicId}`));
}

export async function myReviews() {
  return unwrap(await api.get('/reviews/me'));
}

export async function clinicReply(reviewId, reply) {
  return unwrap(await api.post(`/reviews/${reviewId}/reply`, { reply }));
}

export async function adminListReviews(params = {}) {
  return unwrap(await api.get('/admin/reviews', { params }));
}

export async function adminSetReviewVisibility(id, isVisible) {
  return unwrap(await api.put(`/admin/reviews/${id}/visibility`, { isVisible }));
}
